/**
 * ModerationNotice — al posto di un puzzle che non si può mostrare (#65):
 * perché hai bloccato chi l'ha mandato, o perché non è disponibile (rimosso,
 * nascosto da chi modera, o link sbagliato).
 */
import React from "react";
import { useTranslation } from "react-i18next";

export default function ModerationNotice({ kind, onHome }) {
  const { t } = useTranslation();
  const chiavi =
    kind === "blocked"
      ? ["ui.moderation.blockedTitle", "ui.moderation.blockedBody"]
      : ["ui.moderation.unavailableTitle", "ui.moderation.unavailableBody"];

  return (
    <div
      data-testid={`moderation-${kind}`}
      style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}
    >
      <div
        style={{
          background: "var(--color-surface, #fff)",
          borderRadius: "2rem",
          padding: 28,
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 16px 48px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 800, color: "var(--color-text)", margin: "0 0 10px" }}>
          {t(chiavi[0])}
        </h2>
        <p style={{ fontFamily: "var(--font-body)", fontSize: 15, lineHeight: 1.55, color: "var(--color-textMuted)", margin: "0 0 22px" }}>
          {t(chiavi[1])}
        </p>
        <button
          type="button"
          onClick={onHome}
          style={{
            padding: "12px 24px",
            border: "none",
            borderRadius: 16,
            fontFamily: "var(--font-body)",
            fontSize: 15,
            fontWeight: 700,
            background: "linear-gradient(135deg, var(--color-primary, #a8275a), var(--color-primaryBright, #ff709f))",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          {t("ui.moderation.goHome")}
        </button>
      </div>
    </div>
  );
}
